import './index.less'
const FooterNew = () => {
  return (
    <div className="footer-wrap">
      <div className="footer">
        <div className="footer-bottom">
          <div className="contacts">
            <div className="contacts-title">联系我们</div>
            <div className="contacts-col1">
              <div className="contacts-item">
                <img className="contacts-btn" src={require("../../assets/images/footer/footer-phone.png")} alt="" />
                <span>400-075-9500 转2</span>
              </div>
            </div>
            
            <div className="contacts-col2">
              <div className="contacts-item">
                <img className="contacts-btn" src={require("../../assets/images/footer/footer-address.png")} alt="" />
                <span>深圳市福田区槟榔道3号深港国际科技园D栋3楼</span>
              </div>
            </div>
            <div className="contacts-col3">
              <div className="contacts-item">
                <img className="contacts-btn" src={require("../../assets/images/footer/footer-mail.png")} alt="" />
                <span>
                  <a className="email" target="blank" href="mailto:partner@kaihong.com">
                    partner@kaihong.com
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div className="contacts-divider-content">
            <div className="contacts">
              <div className="contacts-title">友情链接</div>
              <div className="contacts-item"> <a href="https://www.kaihong.com/" target="_blank" rel="noopener noreferrer"> 开鸿官网 </a> </div>
              <div className="contacts-item"> <a href="https://mall.kaihong.com/" target="_blank" rel="noopener noreferrer"> 生态服务中心 </a> </div>
              <div className="copy">
                深圳开鸿数字产业发展有限公司版权所有 |
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">
                  粤ICP备2021164206号
                </a>
              </div>
            </div>
            <div className="contacts">
              <div className="contacts-title">关注我们</div>
              <div className="btn-wx-wrap contacts-btn-wrap">
                <div className="btn-wx contacts-btn">
                  <div className="img-wrap">
                    <img src={require("../../assets/images/footer/footer-wx-qrcode.png")} alt="" />
                  </div>
                  <span>微信公众号</span>
                </div>
              </div>
              <div className="btn-video-wrap contacts-btn-wrap">
                <div className="btn-video contacts-btn">
                  <div className="img-wrap">
                    <img src={require("../../assets/images/footer/footer-video-qrcode.png")} alt="" />
                  </div>
                  <span>微信视频号</span>
                </div>
              </div>
              <div className="btn-weibo-wrap contacts-btn-wrap">
                <div className="btn-weibo contacts-btn">
                  <div className="img-wrap">
                    <img src={require("../../assets/images/footer/footer-weibo-qrcode.png")} alt="" />
                  </div>
                  <span>微博号</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterNew;
